import { motion } from "framer-motion";
import { STEPS } from "../../data";
import { Reveal, Kicker } from "./Reveal";

export default function ApplySteps() {
  return (
    <section data-testid="apply-steps-section" className="py-24 lg:py-32 bg-ink text-sand">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <Reveal><span className="text-xs uppercase tracking-[0.32em] text-brass font-semibold">The Journey</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.08]">Four steps into the ecosystem</h2>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <motion.div data-testid="apply-step-card" whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 280, damping: 22 }}
                className="h-full rounded-3xl border border-sand/12 bg-white/[0.03] p-7 hover:border-gold/50 transition-colors">
                <div className="font-display text-4xl text-gold">{s.n}</div>
                <h3 className="mt-5 font-serif text-xl text-sand">{s.title}</h3>
                <p className="mt-2.5 text-sand/60 leading-relaxed text-sm">{s.desc}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
